export default {"src":"/_next/static/media/youtube.ce972d4e.svg","height":36,"width":50,"blurWidth":0,"blurHeight":0};